export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    border: '1px solid #EDEFF7',
    borderTop: '0',
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
    height: '52px',
    width: '100%',
    cursor: 'pointer',
    padding: '0px 18px',
  },
  createAudienceText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '146%',
    color: '#4D6EF5',
  },
};
